import React, { useEffect } from "react";
import "./Transition.css";
import { useNavigate } from 'react-router-dom';
import { RECOMMENDATIONS_URL_PARAM, useWithRecommendations } from "../RecommenderPage/use-with-recommendations";
import { addUrlParams } from "../../api";

export const NAME_URL_PARAM = "name";
export const SESSION_ID_URL_PARAM = "sessionId";
export const TIMESTAMP_START_URL_PARAM = "timestampStart";

const Transition = () => {
  const navigate = useNavigate();
  const { generateRecommendations } = useWithRecommendations();

  useEffect(() => {
    // check for recommendation url params
    const urlParams = new URLSearchParams(window.location.search);
    const name = urlParams.get(NAME_URL_PARAM);
    const sessionId = urlParams.get(SESSION_ID_URL_PARAM);
    const timestampStart = urlParams.get(TIMESTAMP_START_URL_PARAM);

    if (!name || !sessionId || !timestampStart) {
      console.info("Missing URL parameters");
      navigate("/recommenderpage");
      return;
    }

    const generateAndNavigateRecommendations = async () => {
      const recommendations = await generateRecommendations(name, sessionId, timestampStart);
      const targetPage = recommendations.recommendedPages.length > 0 ? `/recommenderpage${recommendations.recommendedPages[0].pageRoute}` : "/recommenderpage";
      navigate(addUrlParams(targetPage, {
        [RECOMMENDATIONS_URL_PARAM]: JSON.stringify(recommendations)
      })); 
    }

    generateAndNavigateRecommendations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
        <div className="loading-screen">
          <div className="dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <p className="loading-text">
            Gathering recommendations<br/> for next
            steps in your career exploration ...
          </p>
        </div>
    </div>
  );
};

export default Transition;
